'use strict';

const $ = require('jquery');

class Popup {

    constructor() {

        this.initializePopup();

    }

    initializePopup() {

        let $popupLinks = $('[data-popup="inline"]');

        if ($popupLinks.length > 0) {

            require('./../../../../build/node_modules/@components/magnific-popup/dist/jquery.magnific-popup.js');

            $popupLinks.magnificPopup({
                type: 'inline',
            });

            $popupLinks.each(function (i, element) {                                        
                let $link = $(element);
                let popupLink = $link.data('popup-link');
                
                // if the pop-up contains a html video element
                const vid = $(popupLink + ' video');
                if (vid) {
                    $link.magnificPopup({
                        callbacks: {
                            open: function() {
                                vid.trigger('play');
                                vid.prop('muted', false);
                            },
                            close: function() {
                                vid.trigger('pause');
                                vid.prop('muted', true);
                            }
                        }
                    });
                }

                // Opens content in a popup
                $link.attr('href', popupLink);

            });

        }

    }

}

module.exports = Popup;
